import React, { useContext } from 'react';

import { ASSET_PATH } from '../../../../assetsPath';
import { MYBIZ_DEFAULT_LOGOS, MYBIZ_LOGO_IMAGES } from 'AppConstants';

import BannerCarousel from '../../../bizLanding/components/BannerCarousel/BannerCarousel';

import { isMobileContext } from '../../../UtilityComponents/Util';
import DisplayContext from '../../../UtilityComponents/displayContext';

import { bannerCarouselData } from '../config';

const mainImagePng = `${ASSET_PATH.IMAGES}seo/expense/banner.png`;

const SeoCarousel = (props) =>{
	const displayName = useContext(DisplayContext).isMobile;
	const isMobile = isMobileContext(displayName);
	return (
		<BannerCarousel
			mybizLogo={MYBIZ_LOGO_IMAGES.BY_MMT_LIGHT || MYBIZ_DEFAULT_LOGOS.BY_MMT_LIGHT}
			mainImages={{ mainImagePng }}
			bannerCarouselData={bannerCarouselData}
			isMobile={isMobile}
			isFullWidth
			height='575'
			imgOverlay
			bannerImgWidth='50%'
			{...props}
		/>
	);
};

export default SeoCarousel;
